import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import { useGlobalConfigContext } from '../../../../global-config'
import { priceGetFormattedPrice } from '../../../../price'
import { TosSuperscript } from '../../../../tos-superscripts'
import { ProductPrescriptionBonusDialog } from '../../ProductPrescriptionBonusDialog/ProductPrescriptionBonusDialog'

type PrescriptionBadgeContentProps = {
  bonus: number
  className?: string
  'data-qa-id'?: string
  showInfo?: boolean
}

export const PrescriptionBadgeContent: FC<PrescriptionBadgeContentProps> = ({
  bonus,
  className,
  'data-qa-id': dataQaId,
  showInfo,
}) => {
  const modalControls = useOpenableControls()
  const intl = useIntl()
  const { superScripts } = useGlobalConfigContext()

  const content = (
    <>
      <span className="font-mono font-medium">
        {priceGetFormattedPrice(bonus, intl)}
      </span>{' '}
      <FormattedMessage id="general.label.bonus" />
      <TosSuperscript value={superScripts.bonus} />
    </>
  )

  const commonProps = {
    className: clsx(
      'whitespace-nowrap rounded-full bg-light-tertiary px-2 py-1 text-xs font-medium',
      className,
    ),
    'data-qa-id': dataQaId,
  }

  if (showInfo) {
    return (
      <>
        <button
          {...commonProps}
          className={clsx(commonProps.className, 'flex items-center gap-1')}
          onClick={modalControls.handleOpen}
          type="button"
        >
          <span>{content}</span>
          <IconInfo className="size-4" />
        </button>
        <ProductPrescriptionBonusDialog
          isOpen={modalControls.isOpen}
          onClose={modalControls.handleClose}
        />
      </>
    )
  }

  return (
    <span
      {...commonProps}
      className={clsx(commonProps.className, 'inline-block')}
    >
      {content}
    </span>
  )
}
